/**
 * Category color utilities for badges and backgrounds
 */

export const getCategoryBadgeColor = (categoryName: string): string => {
	switch (categoryName) {
		case 'AI i Cyberbezpieczeństwo':
			return '#EA9DD0';
		case 'HR, kadry i płace':
			return '#F5AF87';
		case 'Kompetencje miękkie':
			return '#ACBEF1';
		case 'KSeF':
			return '#5ABEB9';
		case 'Podatki':
			return '#E8E8A1';
		case 'Prawo':
			return '#F8CA56';
		case 'Rachunkowość':
			return '#B1DBBB';
		case 'Szkolenia biznesowe':
			return '#FFFFFF';
		case 'Warsztaty':
			return '#FFFFFF';
		default:
			return '#FFFFFF';
	}
};

export const getCategoryTextColor = (categoryName: string): string => {
	switch (categoryName) {
		case 'AI i Cyberbezpieczeństwo':
			return '#422E5A';
		case 'HR, kadry i płace':
			return '#65191F';
		case 'Kompetencje miękkie':
			return '#522038';
		case 'KSeF':
			return '#162C38';
		case 'Podatki':
			return '#102A41';
		case 'Prawo':
			return '#283A39';
		case 'Rachunkowość':
			return '#373C77';
		case 'Szkolenia biznesowe':
			return '#070314';
		case 'Warsztaty':
			return '#070314';
		default:
			return '#070314';
	}
};

export const getCategoryGradient = (categoryName: string): string => {
	switch (categoryName) {
		case 'AI i Cyberbezpieczeństwo':
			return 'linear-gradient(135deg, #422E5A 0%, #5A3E7B 100%)';
		case 'HR, kadry i płace':
			return 'linear-gradient(135deg, #65191F 0%, #87232B 100%)';
		case 'Kompetencje miękkie':
			return 'linear-gradient(135deg, #522038 0%, #7D3959 100%)';
		case 'KSeF':
			return 'linear-gradient(135deg, #162C38 0%, #274A5D 100%)';
		case 'Podatki':
			return 'linear-gradient(135deg, #102A41 0%, #21527D 100%)';
		case 'Prawo':
			return 'linear-gradient(135deg, #283A39 0%, #436664 100%)';
		case 'Rachunkowość':
			return 'linear-gradient(135deg, #373C77 0%, #565B95 100%)';
		case 'Szkolenia biznesowe':
			return 'linear-gradient(135deg, #070314 0%, #2F3045 100%)';
		case 'Warsztaty':
			return 'linear-gradient(135deg, #070314 0%, #2F3045 100%)';
		default:
			return 'linear-gradient(135deg, #070314 0%, #2F3045 100%)';
	}
};

/**
 * Get category colors for badges with both background and text color
 */
export const getCategoryBadgeStyle = (categoryName: string) => {
	return {
		backgroundColor: getCategoryBadgeColor(categoryName),
		color: getCategoryTextColor(categoryName),
		border: 'none'
	};
};
